/**
 * HTML Element
 *
 */

import Td from '../components/table/TableTd'
export * from '../components/table/TableTd'
export default Td
